import React, { ReactElement } from 'react';

interface MultilineTextProps {
  text: string;
}

export function MultilineText({ text }: MultilineTextProps): ReactElement {
  return (
    <>
      {text.split('\\n').map((line, index) => (
        <p key={`multiline-${index}`}>{line}</p>
      ))}
    </>
  );
}
